/*
 * rheincool — Ergebnis-Produktzeile (ResultProductRow, HANDOFF §8.3)
 * Abonniert window.rcStore auf den konfigurierten Store-Key und ersetzt
 * "{wert}" im Titel-Template durch das gewählte Feld des Store-Objekts
 * (deutsch formatiert). Ohne Store-Wert bleibt der Fallback-Titel stehen.
 * Store-Keys/Felder: kw (kw) · energy (ersparnis …) · heating
 * (ersparnisSaison …) · breakeven (sommer) · matcher (zweck, handle).
 */
class RcResultProducts extends HTMLElement {
  connectedCallback() {
    this.titleEl = this.querySelector('[data-rp-title]');
    const storeKey = this.dataset.storeKey;
    const field = this.dataset.valueField;
    const template = this.dataset.titleTemplate || '';
    const fallback = this.dataset.titleFallback || '';

    if (!this.titleEl || !storeKey || !template.includes('{wert}') || !window.rcStore) return;

    window.rcStore.subscribe(storeKey, (value) => {
      const raw = value && typeof value === 'object' ? value[field] : value;
      if (raw === undefined || raw === null || raw === '') {
        this.titleEl.textContent = fallback;
        return;
      }
      const formatted =
        typeof raw === 'number'
          ? new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 }).format(raw)
          : String(raw);
      this.titleEl.textContent = template.replaceAll('{wert}', formatted);
    });
  }
}

if (!customElements.get('rc-result-products')) {
  customElements.define('rc-result-products', RcResultProducts);
}
